
import { Arc1255BluetoothNfcReader } from "@/utils/arc-1255-bluetooth-nfc-reader";
import { ElectronFunctions } from "@/utils/electron/electron";
import { UnifiedNfcReader } from "@/utils/unified-nfc-reader";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			settings: ElectronFunctions.getNfcSettings(),
			autoConnectArc1255: UnifiedNfcReader.getAutoConnectToArc1255(),
			webSocketServerUrl: UnifiedNfcReader.getWebSocketUrl()
		};
	},
	computed: {
		canConnectToArc1255():boolean{
			return Arc1255BluetoothNfcReader.canConnect();
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			ElectronFunctions.setNfcSettings(this.settings);
			UnifiedNfcReader.setAutoConnectToArc1255(this.autoConnectArc1255);
			UnifiedNfcReader.setWebSocketUrl(this.webSocketServerUrl);
			this.close();
		},
	},
	i18nEx: {
		componentPrefix: "components.LockScreen"
	}
});
